import Clip from './clip/clip.js'


let popup = {}

Vue.use(Clip, {
    router: VueRouter.router,
    root: popup
});


export default popup;